export default {
  zh: {
    index: '首页'
  },
  en: {
    index: 'Home'
  }
}
